import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "next/image";
import cx from "classnames";
import { Text } from "@cinch-labs/design-system";
import { Env, readFromEnv } from "@cinch-nx/environments";
import FooterLinksList from "./footer-links-list/footer-links-list";
import SocialLinkList from "./social-link-list/social-link-list";
import SocialMediaLinkList from "./social-media-link-list/social-media-link-list";
import { footerLinks, socialLinks, socialMediaLinks } from "./data";
import styles from "./shared-ui-footer.module.css";
export function SharedUiFooter(param) {
    var _showFooterBorderRadius = param.showFooterBorderRadius, showFooterBorderRadius = _showFooterBorderRadius === void 0 ? true : _showFooterBorderRadius;
    return /*#__PURE__*/ _jsx("footer", {
        className: cx(styles.footer, _define_property({}, styles.noBorderRadius, !showFooterBorderRadius)),
        id: "main-footer",
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.footerContainer,
            children: [
                /*#__PURE__*/ _jsxs(Text, {
                    element: "h2",
                    className: styles.heading,
                    fontSize: "m",
                    lineHeight: "body",
                    fontWeight: "bold",
                    children: [
                        "Need a hand?",
                        /*#__PURE__*/ _jsx(Text, {
                            element: "span",
                            className: styles.subHeading,
                            fontSize: "s",
                            lineHeight: "body",
                            children: "We're ready to help 8am-8pm, 7 days a week."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(SocialLinkList, {
                    links: socialLinks
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.appStoreButtons,
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            href: readFromEnv(Env.IOSAppStoreUrl),
                            "aria-label": "app store badge",
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: "https://a.storyblok.com/f/132543/384x114/7266ad02b3/download-app-store.png",
                                height: 48,
                                width: 164,
                                alt: "Download on the app store"
                            })
                        }),
                        /*#__PURE__*/ _jsx("a", {
                            href: readFromEnv(Env.AndroidAppStoreUrl),
                            "aria-label": "google play badge",
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: "https://a.storyblok.com/f/132543/564x168/9d227fc037/google-play-badge1.png",
                                height: 48,
                                width: 164,
                                alt: "Get it on google play"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Text, {
                    element: "p",
                    className: styles.body,
                    fontSize: "s",
                    fontWeight: "light",
                    lineHeight: "body",
                    children: "Cinch Cars Limited is an appointed representative of ITC Compliance Limited which is authorised and regulated by the Financial Conduct Authority (their registration number is 313486). Permitted activities include acting as a credit broker not a lender."
                }),
                /*#__PURE__*/ _jsx(Text, {
                    element: "p",
                    className: styles.body,
                    fontSize: "s",
                    fontWeight: "light",
                    lineHeight: "body",
                    children: "We can introduce you to a limited number of finance providers. We do not charge fees for our Consumer Credit services. We may receive a payment(s) or other benefits from finance providers should you decide to enter into an agreement with them, typically either a fixed fee or a fixed percentage of the amount you borrow. The payment we receive may vary between finance providers and product types. The payment received does not impact the finance rate offered."
                }),
                /*#__PURE__*/ _jsx(Text, {
                    element: "p",
                    className: styles.body,
                    fontSize: "s",
                    fontWeight: "light",
                    lineHeight: "body",
                    children: "All finance applications are subject to status, terms and conditions apply, UK residents only, 18’s or over, Guarantees may be required."
                }),
                /*#__PURE__*/ _jsx(Text, {
                    element: "p",
                    className: styles.body,
                    fontSize: "s",
                    fontWeight: "light",
                    lineHeight: "body",
                    children: "We accept Visa and Mastercard debit and credit cards."
                }),
                /*#__PURE__*/ _jsx(FooterLinksList, {
                    links: footerLinks
                }),
                /*#__PURE__*/ _jsx(SocialMediaLinkList, {
                    links: socialMediaLinks
                })
            ]
        })
    });
}
export default SharedUiFooter;
